import { Injectable, inject } from '@angular/core';
import { BoxesEntry, RegressionEntry } from '@models';
import {
  AppService,
  DetectionService,
  MessageService,
  SnackbarService,
  TaskService,
} from '@services';
import JSZip from 'jszip';

@Injectable({
  providedIn: 'root',
})
export class MlPlayerService {
  private detectionService = inject(DetectionService);
  private appService = inject(AppService);
  private taskService = inject(TaskService);
  private messageService = inject(MessageService);
  private snackbarService = inject(SnackbarService);

  private tracking: BoxesEntry[] | RegressionEntry[] = [];

  async loadFiles(files: FileList) {
    if (files) {
      const movieFile = Array.from(files).find((file) =>
        file.name.endsWith('.mp4'),
      );
      const trackingZip = Array.from(files).find((file) =>
        file.name.endsWith('.zip'),
      );
      if (movieFile) {
        const videoElement = document.getElementById(
          'video',
        ) as HTMLVideoElement;
        videoElement.src = URL.createObjectURL(movieFile);
        videoElement.load();
        videoElement.play();
      } else {
        this.snackbarService.showSnackBar({
          message: 'No .mp4 file found in directory',
        });
      }
      if (trackingZip) {
        const arrayBuffer = await trackingZip.arrayBuffer();
        try {
          const zip = await JSZip.loadAsync(arrayBuffer);
          const trackingFile = Object.keys(zip.files).find((fileName) =>
            fileName.endsWith('.json'),
          );
          const trackingFileContent = await zip
            .file(trackingFile)!
            .async('text');
          const trackingData = JSON.parse(trackingFileContent);
          this.tracking = trackingData.tracking;
        } catch (error) {
          this.snackbarService.showSnackBar({
            message: 'Error reading zip file',
          });
        }
      }
      this.startPlayback();
    }
  }

  startPlayback(): void {
    this.appService.trackingMode.set(true);
    this.taskService.restartTasks();
    const videoElement = document.getElementById('video') as HTMLVideoElement;
    let index = 0;
    const playbackCycle = setInterval(() => {
      let tracking = this.tracking[index];
      if (!tracking?.time) {
        clearInterval(playbackCycle);
      }
      if (tracking?.time < videoElement.currentTime * 1000) {
        if ((tracking as unknown as BoxesEntry)?.detections[0]?.objectIndex) {
          tracking = tracking as unknown as BoxesEntry;
          this.detectionService.updateBoxes(
            tracking.workerId,
            tracking.detections,
          );
          this.detectionService.debugRender();
          index++;
        } else {
          tracking = tracking as unknown as RegressionEntry;
          this.detectionService.updateRegression(
            tracking.workerId,
            tracking.detections,
          );
          index++;
        }
      }
    }, 50);
  }
}
